<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/espace-client" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour a l'espace client</a>
      <span class="crumb-current">{{ 'PROFILE.TITLE' | translate }}</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Profil utilisateur</p>
        <h1>Informations personnelles</h1>
        <p class="lead">Mettez à jour vos coordonnées, sécurisez votre compte et gérez votre mot de passe.</p>
        <div class="pill-row">
          <span class="pill pill-strong">{{this.user.firstname}}
            {{this.user.lastname}}</span>
          <span class="pill">{{this.user.username}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card-glass p-3">
    <ul class="nav nav-pills glass-tabs" id="profileTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="infos-tab" data-bs-toggle="tab" data-bs-target="#infos" type="button"
          role="tab" aria-controls="infos" aria-selected="true">Mes infos</button>
      </li>
      <!--*ngIf="!isSecure"-->
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="security-tab" data-bs-toggle="tab" data-bs-target="#security" type="button"
          role="tab" aria-controls="security" aria-selected="false">Sécurité</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="forgotpin-tab" data-bs-toggle="tab" data-bs-target="#forgotpin" type="button"
          role="tab" aria-controls="forgotpin" aria-selected="false">PIN oublié</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="password-tab" data-bs-toggle="tab" data-bs-target="#password" type="button"
          role="tab" aria-controls="password" aria-selected="false">Mot de passe</button>
      </li>
      <li class="nav-item" role="langue">
        <button class="nav-link" id="language-tab" data-bs-toggle="tab" data-bs-target="#language" type="button"
          role="tab" aria-controls="language" aria-selected="false">Langue</button>
      </li>
    </ul>

    <div class="tab-content mt-3" id="profileTabsContent">
      <div class="tab-pane fade show active" id="infos" role="tabpanel" aria-labelledby="infos-tab">
        <div *ngIf="isedit; else readBlock" class="card card-glass border-0">
          <div class="card-body">
            <form [formGroup]="userForm" #u="ngForm" (ngSubmit)="updateUserInformation(u.value)" class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Email</label>
                <input formControlName="email" type="text" class="form-control" placeholder="Email">
              </div>
              <div class="col-md-6">
                <label class="form-label">Nom</label>
                <input formControlName="lastName" type="text" class="form-control" placeholder="Nom">
              </div>
              <div class="col-md-6">
                <label class="form-label">Prénom</label>
                <input type="text" formControlName="firstName" class="form-control" placeholder="Prénom">
              </div>
              <div class="col-md-6">
                <label class="form-label">Téléphone</label>
                <input type="text" formControlName="phone" class="form-control" placeholder="Téléphone">
              </div>
              <div class="d-flex justify-content-end gap-2 mt-2">
                <button type="submit" [disabled]="!userForm.valid" class="btn btn-primary btn-pill">Enregistrer</button>
                <button type="button" (click)="stop()" class="btn btn-outline-light btn-pill">Annuler</button>
              </div>
            </form>
          </div>
        </div>
        <ng-template #readBlock>
          <div class="card card-glass border-0">
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label">Email</label>
                  <input type="text" class="form-control-plaintext text-light"
                    [value]="this.userSessionService.getUser().username" readonly>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Nom</label>
                  <input type="text" class="form-control-plaintext text-light"
                    [value]="this.userSessionService.getUser().lastname" readonly>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Prénom</label>
                  <input type="text" class="form-control-plaintext text-light"
                    [value]="this.userSessionService.getUser().firstname" readonly>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Téléphone</label>
                  <input type="text" class="form-control-plaintext text-light"
                    [value]="this.userSessionService.getUser().phone" readonly>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" (click)="editer()" class="btn btn-primary btn-pill">Modifier</button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <div class="tab-pane fade" id="security" role="tabpanel" aria-labelledby="security-tab">
        <div class="card card-glass border-0">
          <div class="card-body">
            <h5 class="mb-3">Renforcer la sécurité</h5>
            <p *ngIf="samecode" class="text-danger">Votre code secret et votre code de contrainte doivent être
              différents.</p>
            <div *ngIf="!secure; else alreadySecure">
              <form [formGroup]="questionResponse" #f="ngForm" (ngSubmit)="setupSecurity()" class="row g-3">
                <div class="col-md-6">
                  <label class="form-label">Question secrète</label>
                  <select formControlName="question" name="question" id="question" required class="form-select">
                    <option value="">Choisir...</option>
                    <option value="Quel est le nom de votre chien">Quel est le nom de votre chien</option>
                    <option value="Quelle est la marque de votre téléphone">Quelle est la marque de votre téléphone
                    </option>
                    <option value="Quel est votre film préféré">Quel est votre film préféré</option>
                    <option value=" Quel est votre série préféré">Quelle est votre série préférée</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Réponse secrète</label>
                  <input type="text" (keyup)="sendit3($event.target.value)" formControlName="reponse" required
                    minlength="4" maxlength="15" class="form-control" name="reponse" id="reponse">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Code secret</label>
                  <input formControlName="secretpin" (keyup)="sendit1($event.target.value)" type="text"
                    class="form-control" id="secretpin" minlength="6" maxlength="6">
                  <small>6 chiffres</small>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Code de contrainte</label>
                  <input formControlName="contraintpin" (keyup)="sendit2($event.target.value)" type="text"
                    class="form-control" id="contraintpin" minlength="6" maxlength="6">
                  <small>6 chiffres</small>
                </div>
                <div class="d-flex justify-content-end mt-2">
                  <button type="submit" class="btn btn-primary btn-pill"
                    [disabled]="!questionResponse.valid">Ajouter</button>
                </div>
              </form>
            </div>
            <!-- Cas 2 : sécurité déjà configurée -->
            <ng-template #alreadySecure>
              <p>Votre sécurité est déjà configurée.</p>
              <p>Question secrète : <strong>{{ secretQuestion }}</strong></p>
              <p *ngIf="isverify" class="text-danger">Mauvaise réponse secrète.</p>
              <p *ngIf="showssuccess" class="text-success fw-bolder">Vos codes ont été mis à jour avec succès.</p>

              <!-- Formulaire pour réinitialiser les PIN via réponse secrète -->
              <form [formGroup]="resetPinsForm" (ngSubmit)="updateSecurityCode()">
                <div class="g-3">
                  <div class="col-md-2 mb-3">
                    <label class="form-label">Réponse secrète</label>
                    <input formControlName="answer" type="text" class="form-control" (blur)="onAnswerBlur()" />
                    <small *ngIf="isverify" class="text-danger">
                      Réponse incorrecte
                    </small>
                  </div>
                  <div class="col-md-12 row" *ngIf="answerValid">
                    <div class="col-md-3 mb-3">
                      <label class="form-label">Ancien code secret</label>
                      <input formControlName="oldSecretPin" type="text" [disabled]="!answerValid" class="form-control"
                        pattern="[0-9]{6}" inputmode="numeric" minlength="6" maxlength="6" />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Nouveau code de secret</label>
                      <input formControlName="newSecretPin" type="text" [disabled]="!answerValid" class="form-control"
                        pattern="[0-9]{6}" inputmode="numeric" minlength="6" maxlength="6" />
                    </div>
                  </div>
                </div>
                <div *ngIf="answerValid" class="d-flex justify-content-end mt-2">
                  <button type="submit" class="btn btn-primary btn-pill"
                    [disabled]="!resetPinsForm.valid || !answerValid">
                    Mettre à jour les codes
                  </button>
                </div>
              </form>
            </ng-template>

          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="forgotpin" role="tabpanel" aria-labelledby="forgotpin-tab">
        <div class="card card-glass border-0">
          <div class="card-body">
            <h5 class="mb-3">Réinitialiser le code secret par email</h5>
            <p class="text-muted mb-3">Processus en 2 étapes : demande d'OTP par email puis confirmation avec un nouveau
              code secret.</p>

            <div *ngIf="forgotMessage" class="alert alert-info py-2">{{ forgotMessage }}</div>
            <div *ngIf="forgotError" class="alert alert-danger py-2">{{ forgotError }}</div>
            <div *ngIf="forgotSuccess && !forgotError" class="alert alert-success py-2">Action enregistrée.</div>

            <div class="row g-4">
              <div class="col-md-6">
                <div class="p-3 rounded glass-subcard h-100">
                  <h6 class="d-flex align-items-center justify-content-between">1. Demander le code
                    <span class="badge bg-secondary">OTP</span>
                  </h6>
                  <form [formGroup]="forgotInitForm" (ngSubmit)="submitForgotInit()" class="mt-2">
                    <label class="form-label">Email ou identifiant</label>
                    <input type="text" class="form-control" formControlName="usernameOrEmail"
                      placeholder="email ou identifiant">
                    <small class="text-muted">Un email sera envoyé si le compte existe.</small>
                    <div class="d-flex gap-2 mt-3">
                      <button type="submit" class="btn btn-primary btn-pill"
                        [disabled]="forgotInitForm.invalid || forgotLoading">Envoyer le code</button>
                      <button type="button" class="btn btn-outline-light btn-pill" (click)="resendForgotInit()"
                        [disabled]="resendCooldown>0 || forgotLoading">Renvoyer <span
                          *ngIf="resendCooldown>0">({{resendCooldown}}s)</span></button>
                    </div>
                    <div class="mt-2 text-muted" *ngIf="otpCountdown>0">
                      Code valable encore {{ (otpCountdown/60) | number:'1.0-0' }} min {{ (otpCountdown%60) |
                      number:'2.0' }} s
                    </div>
                  </form>
                </div>
              </div>

              <div class="col-md-6">
                <div class="p-3 rounded glass-subcard h-100" [class.disabled]="forgotStep==='init'">
                  <h6>2. Confirmer et choisir un nouveau code</h6>
                  <form [formGroup]="forgotConfirmForm" (ngSubmit)="submitForgotConfirm()">
                    <div class="mb-3">
                      <label class="form-label">Email ou identifiant</label>
                      <input type="text" class="form-control" formControlName="usernameOrEmail" [readonly]="true">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Code reçu (6 chiffres)</label>
                      <input type="text" class="form-control" formControlName="otp" inputmode="numeric" maxlength="6"
                        placeholder="123456">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Nouveau code secret</label>
                      <input type="password" class="form-control" formControlName="newSecretPin" inputmode="numeric"
                        pattern="[0-9]{6}" minlength="6" maxlength="6" placeholder="6 chiffres">
                    </div>
                    <button type="submit" class="btn btn-primary btn-pill"
                      [disabled]="forgotConfirmForm.invalid || forgotLoading || forgotStep==='init'">Valider</button>
                  </form>
                  <div *ngIf="forgotLoading" class="text-info mt-2">Traitement en cours...</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="password" role="tabpanel" aria-labelledby="password-tab">
        <div class="card card-glass border-0">
          <div class="card-body">
            <h5 class="mb-3">Modifier ou réinitialiser votre mot de passe</h5>
            <p *ngIf="iscode" class="text-danger">Mauvais code de sécurité</p>
            <p *ngIf="isupdate" class="text-success">{{message}}.</p>
            <form [formGroup]="passwordForm" #p="ngForm" (ngSubmit)="updateUserPassword()" class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Code de sécurité</label>
                <input formControlName='code' name="code" (keyup)="sendit1($event.target.value)" class="form-control"
                  type="text" minlength="6" maxlength="6" inputmode="numeric" pattern="[0-9]{6}" required>
              </div>
              <div class="col-md-4">
                <label class="form-label">Mot de passe</label>
                <input formControlName="password" #pass (focus)="showvalidationpart()" (blur)="hidevalidationpart()"
                  (keyup)="validateValue(pass.value)" name="password" class="form-control" type="password" id="pass"
                  required>
                <small *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">Mot de passe
                  invalide</small>
                <div *ngIf="validation" class="mt-2 password-hints">
                  <p [ngStyle]="{'color':letterchange ? 'lightgreen' : '#ff9b9b' }" id="letter" class="m-0">Minuscule
                  </p>
                  <p [ngStyle]="{'color':capitalchange ? 'lightgreen' : '#ff9b9b' }" id="capital" class="m-0">Majuscule
                  </p>
                  <p [ngStyle]="{'color':numberchange ? 'lightgreen' : '#ff9b9b' }" id="number" class="m-0">Chiffre</p>
                  <p [ngStyle]="{'color':symbolechange ? 'lightgreen' : '#ff9b9b' }" id="symbole" class="m-0">Symbole
                  </p>
                  <p [ngStyle]="{'color':lengthchange ? 'lightgreen' : '#ff9b9b' }" id="length" class="m-0">8-16
                    caractères</p>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Confirmer le mot de passe</label>
                <input formControlName="confirmPassword" name="confirmPassword" class="form-control" type="password"
                  required>
                <small *ngIf="confirmPassword.invalid && (confirmPassword.dirty|| confirmPassword.touched)"
                  class="text-danger">Mot de passe invalide</small>
              </div>
              <div class="d-flex justify-content-end mt-2">
                <button type="submit" class="btn btn-primary btn-pill" [disabled]="!passwordForm.valid">Terminé</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="language" role="tabpanel" aria-labelledby="language-tab">
        <div class="card card-glass border-0">
          <div class="card-body">
            <h5 class="mb-3">Préférence de langue</h5>
            <p>Choisissez votre langue préférée pour l'interface utilisateur.</p>
            <form (ngSubmit)="changeLanguage()" class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Langue</label>
                <select [(ngModel)]="selectedLanguage" name="language" class="form-select">
                  <option value="en">Anglais</option>
                  <option value="fr">Français</option>
                  <option value="es">Espagnol</option>
                  <option value="de">Allemand</option>
                  <option value="it">Italien</option>
                </select>
              </div>
              <div class="d-flex justify-content-end mt-2">
                <button type="submit" class="btn btn-primary btn-pill">Enregistrer</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
